import { useMutation } from '@tanstack/react-query';

import {
  type UpdateUnitMappingMutationOptions,
  type UpdateUnitMappingPayload,
} from './types';
import { updateUnitMapping } from './updateUnitMapping';

/**
 * Custom hook for updating an existing unit mapping from an invalid UN/CEFACT unit to a valid UN/CEFACT unit.
 *
 * @returns {Object} An object containing the mutation function and related properties.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Units/operation/update_unit_mapping_units_unit_mapping__id__put
 */
export const useMutationUpdateUnitMapping = (
  options?: UpdateUnitMappingMutationOptions,
) => {
  return useMutation({
    mutationFn: async ({
      unitMappingId,
      unitMappingData,
    }: UpdateUnitMappingPayload) =>
      updateUnitMapping({
        unitMappingId,
        unitMappingData,
      }),
    ...options,
  });
};
